import {
  ORDER_FULFILLMENT_DELIVERY,
  ORDER_FULFILLMENT_PICKUP
} from "@/constants/order";

export default class Order {
  id;
  requested;
  userId;
  displayName;
  locationId;
  locationName;
  serviceCharge;
  section;
  row;
  seat;
  instructions;
  totalPrice;
  stripePaymentIntentId;
  created;
  status;
  items;
  preparingUserId;
  preparingStartAt;
  deliveringUserId;
  deliveringStartAt;
  readyUserId;
  readyStartAt;
  completedUserId;
  completedAt;
  fulfillment;
  pickupInstructions;

  constructor(
    id,
    requested,
    userId,
    displayName,
    locationId,
    locationName,
    serviceCharge,
    section,
    row,
    seat,
    instructions,
    totalPrice,
    stripePaymentIntentId,
    created,
    status,
    items,
    preparingUserId,
    preparingStartAt,
    deliveringUserId,
    deliveringStartAt,
    readyUserId,
    readyStartAt,
    completedUserId,
    completedAt,
    fulfillment,
    pickupInstructions
  ) {
    this.id = id;
    this.requested = requested;
    this.userId = userId;
    this.displayName = displayName;
    this.locationId = locationId;
    this.locationName = locationName;
    this.serviceCharge = serviceCharge;
    this.section = section;
    this.row = row;
    this.seat = seat;
    this.instructions = instructions;
    this.totalPrice = totalPrice;
    this.stripePaymentIntentId = stripePaymentIntentId;
    this.created = created;
    this.status = status;
    this.items = items;
    this.preparingUserId = preparingUserId;
    this.preparingStartAt = preparingStartAt;
    this.deliveringUserId = deliveringUserId;
    this.deliveringStartAt = deliveringStartAt;
    this.readyUserId = readyUserId;
    this.readyStartAt = readyStartAt;
    this.completedUserId = completedUserId;
    this.completedAt = completedAt;
    this.fulfillment = fulfillment;
    this.pickupInstructions = pickupInstructions;
  }

  /**
   * Obviously, the unique part is the entire string, but this should give
   * people enough to uniquely identify orders, the chance of having the first 6
   * hash letters on the same day is so remote...
   */
  friendlyIdentifier() {
    return (
      this.id.substring(0, 3).toUpperCase() +
      "-" +
      this.id.substring(3, 6).toUpperCase()
    );
  }

  isDelivery() {
    return this.fulfillment !== ORDER_FULFILLMENT_PICKUP;
  }

  static firebaseConverter = {
    fromFirestore(snapshot, options) {
      let id = snapshot.id;
      const data = { id, ...snapshot.data(options) };

      return new Order(
        data.id,
        data.requested ? data.requested.toDate() : null,
        data.userId,
        data.displayName,
        data.locationId,
        data.locationName,
        data.serviceCharge,
        data.section,
        data.row,
        data.seat,
        data.instructions,
        data.totalPrice,
        data.stripePaymentIntentId,
        data.created ? data.created.toDate() : null,
        data.status,
        data.items,
        data.preparingUserId,
        data.preparingStartAt ? data.preparingStartAt.toDate() : null,
        data.deliveringUserId,
        data.deliveringStartAt ? data.deliveringStartAt.toDate() : null,
        data.readyUserId,
        data.readyStartAt ? data.readyStartAt.toDate() : null,
        data.completedUserId,
        data.completedAt ? data.completedAt.toDate() : null,
        data.fulfillment ? data.fulfillment : ORDER_FULFILLMENT_DELIVERY,
        data.pickupInstructions
      );
    },

    toFirestore(order) {
      let {
        id,
        requested,
        userId,
        displayName,
        locationId,
        locationName,
        serviceCharge,
        section,
        row,
        seat,
        instructions,
        totalPrice,
        stripePaymentIntentId,
        created,
        status,
        items,
        preparingUserId,
        preparingStartAt,
        deliveringUserId,
        deliveringStartAt,
        readyUserId,
        readyStartAt,
        completedUserId,
        completedAt,
        fulfillment,
        pickupInstructions
      } = order;
      return {
        id,
        requested,
        userId,
        displayName,
        locationId,
        locationName,
        serviceCharge,
        section,
        row,
        seat,
        instructions,
        totalPrice,
        stripePaymentIntentId,
        created,
        status,
        items,
        preparingUserId,
        preparingStartAt,
        deliveringUserId,
        deliveringStartAt,
        readyUserId,
        readyStartAt,
        completedUserId,
        completedAt,
        fulfillment,
        pickupInstructions
      };
    }
  };
}
